import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';

export enum MyWorkCategory {
  ENTRIES = 'entries',
  WORKSHEETS = 'worksheets',
  TASKS = 'tasks',
}

export type ReviewSummaryStateKey =
  | 'inProgress'
  | 'rejected'
  | 'needsReview'
  | 'sentForReview'
  | 'accepted'
  | 'retracted';

export type TasksReviewSummaryCountKey =
  | 'cancelled'
  | 'completed'
  | 'failed'
  | 'invalid'
  | 'inProgress'
  | 'pending'
  | 'skipped';

export const REVIEW_ITEM_STATUS_LABELS = [
  'In Progress',
  'Needs Revision',
  'Ready for Review',
  'Sent for Review',
  'Accepted',
  'Retracted',
] as const;

export const DEFAULT_REVIEW_STATUS_FILTER: Array<(typeof REVIEW_ITEM_STATUS_LABELS)[number]> = [
  'In Progress',
  'Needs Revision',
  'Ready for Review',
];

export const TASK_STATUS_LABELS = [
  'Cancelled',
  'Completed',
  'Failed',
  'Invalid',
  'In Progress',
  'Pending',
  'Skipped',
] as const;

export const DEFAULT_TASK_STATUS_FILTER: Array<(typeof TASK_STATUS_LABELS)[number]> = [
  'Failed',
  'Invalid',
  'In Progress',
  'Pending',
];

export const REVIEW_STATUS_LABEL_TO_SUMMARY_KEY: Record<string, ReviewSummaryStateKey> = {
  'In Progress': 'inProgress',
  'Needs Revision': 'rejected',
  'Ready for Review': 'needsReview',
  'Sent for Review': 'sentForReview',
  Accepted: 'accepted',
  Retracted: 'retracted',
  Rejected: 'rejected',
};

export const TASK_STATUS_LABEL_TO_SUMMARY_KEY: Record<string, TasksReviewSummaryCountKey> = {
  Cancelled: 'cancelled',
  Completed: 'completed',
  Failed: 'failed',
  Invalid: 'invalid',
  'In Progress': 'inProgress',
  Pending: 'pending',
  Skipped: 'skipped',
};

export const TASK_STATUS_TYPE_TO_SUMMARY_KEY: Record<ProcessTaskStatusType, TasksReviewSummaryCountKey> = {
  [ProcessTaskStatusType.CANCELLED]: 'cancelled',
  [ProcessTaskStatusType.COMPLETED]: 'completed',
  [ProcessTaskStatusType.FAILED]: 'failed',
  [ProcessTaskStatusType.INVALID]: 'invalid',
  [ProcessTaskStatusType.IN_PROGRESS]: 'inProgress',
  [ProcessTaskStatusType.PENDING]: 'pending',
  [ProcessTaskStatusType.SKIPPED]: 'skipped',
};

export const REVIEW_SUMMARY_COUNT_KEYS: Array<ReviewSummaryStateKey> = [
  'needsReview',
  'sentForReview',
  'inProgress',
  'rejected',
  'retracted',
  'accepted',
];

export const TASKS_REVIEW_SUMMARY_COUNT_KEYS: Array<TasksReviewSummaryCountKey> = [
  'cancelled',
  'completed',
  'failed',
  'invalid',
  'inProgress',
  'pending',
  'skipped',
];
